import * as React from 'react';
export function useHeadLink(headLink) {
  React.useLayoutEffect(() => {
    if (headLink) {
      const exists = document.querySelector(`link[rel="${headLink.rel}"][href="${headLink.href}"]`);
      if (!exists) {
        const head = document.querySelector('head');
        const link = document.createElement('link');
        Object.keys(headLink).forEach(attr => {
          link[attr] = headLink[attr];
        });
        if (head) {
          head.appendChild(link);
        }
      }
    }
  }, []);
}